import * as z from "zod/v4";

const getBrandSummaryInput = z.object({});

const getBrandSummaryOutput = z.object({
  summary: z.string(),
  hasAnalysis: z.boolean(),
});

export const getBrandSummary: {
  name: "getBrandSummary";
  input: typeof getBrandSummaryInput;
  output: typeof getBrandSummaryOutput;
} = {
  name: "getBrandSummary" as const,
  input: getBrandSummaryInput,
  output: getBrandSummaryOutput,
};
